import type { InteractModuleProperties } from "@skilitics/nautilus-endpoint-definition";

const FOLDER_MARKER = "|";

const getModuleName = <T extends InteractModuleProperties>(module: T) =>
  module.title.split(FOLDER_MARKER).pop()?.trim() ?? "";

export const getModulePathDescriptor = (module: InteractModuleProperties, filter: string = "") => {
  const names = module.title.split(FOLDER_MARKER);

  const path = names.slice(0, names.length - 1).join(FOLDER_MARKER);

  if (filter && !module.title.startsWith(filter))
    throw new Error(`Invalid filter "${filter}" specified for module "${module.title}".`);

  const filtered = module.title.replace(filter, "").split(FOLDER_MARKER);

  return {
    name: getModuleName(module),
    path: path ? path.concat(FOLDER_MARKER) : path,
    title: filtered[0].trim(),
    filter: filtered.length !== 1 ? filter.concat(filtered[0]).concat(FOLDER_MARKER) : "",
    isLeaf: filtered.length === 1,
  };
};

export const getFolderNamesFromFilter = (filter: string = "") =>
  filter
    .split(FOLDER_MARKER)
    .map((name) => name.trim())
    .filter((name) => !!name);

export const sliceFolderFilter = (filter: string, index: number) => {
  const names = filter.split(FOLDER_MARKER).filter((name) => !!name);

  if (names.length < index) throw new RangeError(`Slicing index "${index}" is out of range for filter "${filter}".`);

  return names.length
    ? names
        .slice(0, index + 1)
        .join(FOLDER_MARKER)
        .concat(FOLDER_MARKER)
    : "";
};
